import { createContext } from 'react';
import type { ModalContextType } from '@/shared/types/modal';

/**
 * Contexto React para el Modal
 * Separado del provider para evitar warnings de react-refresh
 */
export const ModalContext = createContext<ModalContextType | null>(null);
